import { CERTIFIED_PAYROLL_SETTINGS } from "../../types";

const CertifiedPayrollSettings = (state = {}, action) => {
    if (action.type === CERTIFIED_PAYROLL_SETTINGS) {
        return action.payload;
    };
    return state;
};

export default CertifiedPayrollSettings;